import React from 'react'
import s from './styles/StudentSearchDropdown.module.scss'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'

export const StudentSearchDropdown = ({
	isOpen,
	isLoading,
	results,
	onSelectStudent,
	emptyMessage = 'No students found',
}) => {
	if (!isOpen) return null

	return (
		<div className={s.dropdown}>
			{isLoading && <div className={s.dropdown__empty}>Loading...</div>}
			{!isLoading &&
				results.map(st => (
					<button
						type="button"
						key={st.id}
						className={s.dropdown__option}
						onClick={() => onSelectStudent(st)}
					>
						<span className={s.dropdown__optionPhoto}>
							<InitialAvatar
								name={st.name || 'Student'}
								size={28}
								avatarKey={st.avatarKey}
								avatarSource={st.avatarSource}
								photoUrl={st.photoUrl}
							/>
						</span>
						<span className={s.dropdown__optionName}>{st.name}</span>
						{st.grade && (
							<span className={s.dropdown__optionGrade}>Grade {st.grade}</span>
						)}
					</button>
				))}
			{!isLoading && results.length === 0 && (
				<div className={s.dropdown__empty}>{emptyMessage}</div>
			)}
		</div>
	)
}
